import { Input, Table, Tabs } from "antd";
import styled from "styled-components";

export const CustomTab = styled(Tabs)`
  .ant-tabs-nav::before {
    border: none;
  }
`;
